var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
import { useTypedSelector } from "../state/store";
import * as quizAnswerActions from "../state/quizAnswer/actions";
import { StyledTextField } from "./styleComponents";
import { SpaciousPaper } from "./styleComponents";
import LaterQuizItemAddition from "./LaterQuizItemAddition";
import MarkdownText from "./MarkdownText";
var SolutionPaper = styled(SpaciousPaper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-left: 1rem solid ", ";\n\n  p {\n    margin: 0;\n  }\n"], ["\n  border-left: 1rem solid ", ";\n\n  p {\n    margin: 0;\n  }\n"])), function (props) {
  return props.correct ? "#047500" : "#DB0000";
});

var Open = function Open(_a) {
  var item = _a.item;
  var dispatch = useDispatch();
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var answer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var displayFeedback = useTypedSelector(function (state) {
    return state.feedbackDisplayed;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });

  if (!languageInfo) {
    return React.createElement("div", null);
  }

  var handleTextDataChange = function handleTextDataChange(e) {
    dispatch(quizAnswerActions.changeTextData(item.id, e.currentTarget.value));
  };

  var itemAnswer = answer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });

  if (!itemAnswer && !quizDisabled) {
    return React.createElement(LaterQuizItemAddition, {
      item: item
    });
  }

  var correct = itemAnswer ? itemAnswer.correct : false;
  var textData = itemAnswer ? itemAnswer.textData : "";
  var openLabels = languageInfo.open;
  var answerLocked = userQuizState && userQuizState.status === "locked";
  var itemTitle = item.texts[0].title;
  var _b = item.texts[0],
      successMessage = _b.successMessage,
      failureMessage = _b.failureMessage;
  var guidance = React.createElement(React.Fragment, null, React.createElement(MarkdownText, {
    variant: "h6"
  }, itemTitle), React.createElement(MarkdownText, {
    variant: "body1"
  }, item.texts[0].body));

  if (displayFeedback) {
    var answerPortion = answerLocked ? React.createElement(SpaciousPaper, null, React.createElement(Typography, {
      variant: "body1"
    }, textData)) : React.createElement(StyledTextField, {
      rowNumber: item.order,
      value: textData,
      onChange: handleTextDataChange,
      fullWidth: true,
      margin: "normal",
      variant: "outlined",
      label: openLabels.placeholder
    });
    return React.createElement("div", null, guidance, React.createElement(Typography, {
      variant: "subtitle1"
    }, openLabels.userAnswerLabel, ":"), answerPortion, React.createElement(SolutionPaper, {
      correct: correct
    }, React.createElement(MarkdownText, {
      Component: Typography,
      variant: "body1"
    }, correct ? successMessage || openLabels.feedbackForSuccess : failureMessage || openLabels.feedbackForFailure)));
  }

  return React.createElement("div", null, guidance, React.createElement(StyledTextField, {
    rowNumber: item.order,
    value: textData,
    onChange: handleTextDataChange,
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    label: openLabels.placeholder,
    disabled: quizDisabled
  }));
};

export default Open;
var templateObject_1;